import React from "react";
import { Grid, Divider, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  privacyPolicySection: {
    padding: theme.spacing(5, 1),
    background: theme.palette.background.paper,
    minHeight: "50vh",
  },
  divider: {
    background: theme.palette.text.divider,
    margin: theme.spacing(5),
  },
  commonMargin: {
    margin: theme.spacing(1),
  },
  postPageLeftSection: {
    padding: theme.spacing(1),
    background: theme.palette.background.default,
  },
  postPageRightSection: {
    padding: theme.spacing(1),
    background: theme.palette.background.default,
  },
}));

const PrivacyPolicy = () => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={2}
        className={classes.postPageLeftSection}
      ></Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={8}
        className={classes.postPageMiddleSection}
      >
        <Paper elevation={0} className={classes.privacyPolicySection}>
          {/* <Typography
            component="h4"
            variant="h4"
            className={classes.commonMargin}
          >
            Privacy Policy
          </Typography> */}
          <Typography
            component="h5"
            variant="h5"
            className={classes.commonMargin}
          >
            Disclaimer
          </Typography>
          <Typography
            component="p"
            variant="body1"
            className={classes.commonMargin}
          >
            Maadhyam is an educational website which provides its users/readers
            a light, easy to consume, insight into web development and different
            related/unrelated categories through blogs/articles. All the
            blogs/articles that are available for user consumption are based
            upon the personal experiences and learnings of author/s with
            examples/references taken from other educational websites/blogs. In
            case of technical articles, the care has been taken to provide
            correct/updated information, it is advised to verify the readings
            with official documentations.
          </Typography>
          <Divider className={classes.divider} />
          <Typography
            component="h5"
            variant="h5"
            className={classes.commonMargin}
          >
            Data Usage
          </Typography>
          <Typography
            component="p"
            variant="body1"
            className={classes.commonMargin}
          >
            We do not store any user data unless user has chosen to login
            through google auth, in which case, data such as name, email and
            profile picture is used to provide custom experience to users like
            commenting on a blog/article, replying to a blog/article and may be
            used in future to build more user specific features which makes user
            experience smooth. Also, we do not share any user data with anyone
            and will never do so.
          </Typography>
        </Paper>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={2}
        className={classes.postPageRightSection}
      ></Grid>
    </Grid>
  );
};

export default PrivacyPolicy;
